import { combineReducers } from "redux";

import language from "./language";

export default combineReducers({ language });
